import { render, staticRenderFns } from "./AboutOld.vue?vue&type=template&id=2d2724dd"
import script from "./AboutOld.vue?vue&type=script&lang=js"
export * from "./AboutOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports